import CreatureBlockBasic from './CreatureBlockBasic';

export default CreatureBlockBasic;
export { CreatureBlockBasic };
